import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ferryWheelHistory,
  resetGameCoin,
} from "../../../store/GameHistory/action";
import dayjs from "dayjs";
import { DateRangePicker } from "react-date-range";
import Pagination from "../../../pages/Pagination";
import $ from "jquery";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Diamond from "../../../assets/images/diamond.png";

function FerryWheel() {
  const { gameHistory, total, adminCoin } = useSelector(
    (state) => state.gameHistory,
  );
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [date, setDate] = useState([
    {
      startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1), // First day of current month
      endDate: new Date(), // Current date
      key: "selection",
    },
  ]);
  const [sDate, setsDate] = useState(
    dayjs(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format(
      "YYYY-MM-DD",
    ),
  );
  const [eDate, seteDate] = useState(dayjs(new Date()).format("YYYY-MM-DD"));

  const [activePage, setActivePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const maxDate = new Date();

  useEffect(() => {
    dispatch(ferryWheelHistory(activePage, rowsPerPage, sDate, eDate));
  }, [dispatch, activePage, rowsPerPage]);

  useEffect(() => {
    setData(gameHistory);
  }, [gameHistory]);

  const getAllUser = () => {
    setActivePage(1);
    setsDate("ALL");
    seteDate("ALL");
    dispatch(ferryWheelHistory(activePage, rowsPerPage, "ALL", "ALL"));
  };

  const collapsedDatePicker = () => {
    const datePicker = $("#datePicker");
    if (datePicker.css("display") === "none") {
      datePicker.css("display", "block");
    } else {
      datePicker.css("display", "none");
    }
  };

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setActivePage(1);
    setRowsPerPage(value);
  };

  const handleResetCoin = () => {
    dispatch(resetGameCoin());
  };

  const handleDateChange = (item) => {
    setDate([item.selection]);
  };

  const applyDateFilter = () => {
    const dayStart = dayjs(date[0].startDate).format("YYYY-MM-DD");
    const dayEnd = dayjs(date[0].endDate).format("YYYY-MM-DD");
    setActivePage(1);
    setsDate(dayStart);
    seteDate(dayEnd);
    dispatch(ferryWheelHistory(activePage, rowsPerPage, dayStart, dayEnd));

    // Close the date picker
    const datePicker = document.getElementById("datePicker");
    if (datePicker.classList.contains("show")) {
      datePicker.classList.remove("show");
    }
  };

  const handleDateFilter = () => {
    setActivePage(1);
    $("#datePicker").css("display", "none");
    dispatch(ferryWheelHistory(activePage, rowsPerPage, sDate, eDate));
  };

  return (
    <>
      {/* ── FILTER BAR ── */}
      <div className="row mb-3">
        <div className="col-12">
          <div className="filter-bar">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
              {/* Left — buttons */}
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <button
                  className="btn btn-sm"
                  style={{
                    background: "#1a1f2e",
                    color: "#c8cfe0",
                    border: "1px solid #2a3050",
                    borderRadius: 6,
                  }}
                  onClick={handleResetCoin}
                >
                  Reset Diamond
                </button>
                <button
                  className="edit-btn"
                  style={{ marginRight: 5 }}
                  onClick={getAllUser}
                >
                  All
                </button>
                <button
                  className="edit-btn collapsed"
                  value="check"
                  data-toggle="collapse"
                  data-target="#datePicker"
                  onClick={collapsedDatePicker}
                >
                  Analytics
                  <ExpandMoreIcon style={{ fontSize: 18, marginLeft: 4 }} />
                </button>
                <p style={{ paddingLeft: 10 }} className="my-2 text-secondary">
                  {sDate !== "ALL" && sDate + " to " + eDate}
                </p>
              </div>

              {/* Right — Admin Total Diamonds */}
              <div className="d-flex align-items-center">
                <span style={{ color: "#9CA3AF", fontSize: 13 }}>
                  Admin Total Diamonds :
                  <span style={{ color: "#6ea8fe" }}>
                    &nbsp;&nbsp;{adminCoin}
                  </span>
                </span>
              </div>
            </div>

            {/* Date picker */}
            <div
              id="datePicker"
              className="date-picker-wrapper mt-3"
              aria-expanded="false"
              style={{ display: "none" }}
            >
              <div className="container table-responsive">
                <div key={JSON.stringify(date)}>
                  <DateRangePicker
                    maxDate={maxDate}
                    onChange={(item) => {
                      setDate([item.selection]);
                      const dayStart = dayjs(item.selection.startDate).format(
                        "YYYY-MM-DD",
                      );
                      const dayEnd = dayjs(item.selection.endDate).format(
                        "YYYY-MM-DD",
                      );
                      setsDate(dayStart);
                      seteDate(dayEnd);
                    }}
                    showSelectionPreview={true}
                    moveRangeOnFirstSelection={false}
                    ranges={date}
                    direction="horizontal"
                  />
                </div>
                <div className="mt-3">
                  <button className="edit-btn" onClick={handleDateFilter}>
                    Apply Filter
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── TABLE CARD ── */}
      <div className="row mt-4">
        <div className="col">
          <div className="table-card">
            <div className="table-card-body">
              <div style={{ overflowX: "auto", width: "100%" }}>
                <table className="table" style={{ borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Admin Diamond</th>
                      <th>Win/Lose</th>
                      <th>winner Diamond Minus</th>
                      <th>Total Add Diamond</th>
                      <th>Win Frame</th>
                      <th>Win X Times</th>
                      <th>Date</th>
                      <th>Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.length > 0 ? (
                      data?.map((data, index) => {
                        var gameDate = data?.date ? data?.date.split(",") : [];
                        return (
                          <>
                            <tr
                              data-toggle="collapse"
                              data-target={`#demo${index}`}
                              className="accordion-toggle pointer-cursor"
                            >
                              <td>{index + 1}</td>
                              <td className="text-success">
                                <img
                                  src={Diamond}
                                  width="15"
                                  height="15"
                                  style={{
                                    verticalAlign: "middle",
                                    marginRight: "1px",
                                  }}
                                />
                                {data?.updatedAdminCoin}
                              </td>
                              <td
                                className={
                                  data?.totalAdd + data?.winnerCoinMinus > 0
                                    ? "text-success"
                                    : "text-danger"
                                }
                              >
                                {data?.totalAdd + data?.winnerCoinMinus > 0
                                  ? data?.totalAdd + data?.winnerCoinMinus
                                  : Math.abs(
                                      data?.totalAdd + data?.winnerCoinMinus,
                                    )}
                              </td>
                              <td className="text-danger">
                                <img
                                  src={Diamond}
                                  width="15"
                                  height="15"
                                  style={{
                                    verticalAlign: "middle",
                                    marginRight: "1px",
                                  }}
                                />
                                {parseInt(data?.winnerCoinMinus)}
                              </td>
                              <td className="text-warning">
                                <img
                                  src={Diamond}
                                  width="15"
                                  height="15"
                                  style={{
                                    verticalAlign: "middle",
                                    marginRight: "1px",
                                  }}
                                />
                                {data?.totalAdd}
                              </td>
                              <td className="text-primary">
                                {data?.winnerNumber}
                              </td>
                              <td className="text-success">
                                {data?.winnerNumberTimes}
                              </td>
                              <td className="text-info">{gameDate[0]}</td>
                              <td className="text-primary">{gameDate[1]}</td>
                            </tr>
                          </>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="7" align="center">
                          Nothing to show!!
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <Pagination
                activePage={activePage}
                rowsPerPage={rowsPerPage}
                userTotal={total}
                handleRowsPerPage={handleRowsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default FerryWheel;
